import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [showLogin, setShowLogin] = useState(false);
    const [showResetPassword, setShowResetPassword] = useState(false);

    const triggerLogin = () => {
        setShowLogin(true);
    };

    const closeLogin = () => {
        setShowLogin(false);
    };

    const triggerResetPassword = () => {
        setShowResetPassword(true);
    };

    const closeResetPassword = () => {
        setShowResetPassword(false);
    };

    const value = {
        showLogin,
        showResetPassword,
        triggerLogin,
        closeLogin,
        triggerResetPassword,
        closeResetPassword,
        setShowLogin,
        setShowResetPassword
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
}; 